/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Eliada Sports Agency API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  Application,
  ApplicationInput,
  ApplicationStatusUpdate,
  CmsSection,
  CmsSectionInput,
  ContactInput,
  ContactMessage,
  DeleteResult,
  ErrorEnvelope,
  HealthStatus,
  UploadUrlRequest,
  UploadUrlResponse,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Submit a contact form message
 */
export const getSubmitContactUrl = () => {
  return `/api/contact`;
};

export const submitContact = async (
  contactInput: ContactInput,
  options?: RequestInit,
): Promise<ContactMessage> => {
  return customFetch<ContactMessage>(getSubmitContactUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(contactInput),
  });
};

export const getSubmitContactMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitContact>>,
    TError,
    { data: BodyType<ContactInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitContact>>,
  TError,
  { data: BodyType<ContactInput> },
  TContext
> => {
  const mutationKey = ["submitContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitContact>>,
    { data: BodyType<ContactInput> }
  > = (props) => {
    const { data } = props ?? {};

    return submitContact(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitContact>>
>;
export type SubmitContactMutationBody = BodyType<ContactInput>;
export type SubmitContactMutationError = ErrorType<unknown>;

/**
 * @summary Submit a contact form message
 */
export const useSubmitContact = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitContact>>,
    TError,
    { data: BodyType<ContactInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitContact>>,
  TError,
  { data: BodyType<ContactInput> },
  TContext
> => {
  return useMutation(getSubmitContactMutationOptions(options));
};

/**
 * @summary List all contact messages (admin)
 */
export const getListContactMessagesUrl = () => {
  return `/api/contact`;
};

export const listContactMessages = async (
  options?: RequestInit,
): Promise<ContactMessage[]> => {
  return customFetch<ContactMessage[]>(getListContactMessagesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListContactMessagesQueryKey = () => {
  return [`/api/contact`] as const;
};

export const getListContactMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof listContactMessages>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listContactMessages>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListContactMessagesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listContactMessages>>
  > = ({ signal }) => listContactMessages({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listContactMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListContactMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContactMessages>>
>;
export type ListContactMessagesQueryError = ErrorType<unknown>;

/**
 * @summary List all contact messages (admin)
 */

export function useListContactMessages<
  TData = Awaited<ReturnType<typeof listContactMessages>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listContactMessages>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListContactMessagesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single contact message
 */
export const getGetContactMessageUrl = (id: number) => {
  return `/api/contact/${id}`;
};

export const getContactMessage = async (
  id: number,
  options?: RequestInit,
): Promise<ContactMessage> => {
  return customFetch<ContactMessage>(getGetContactMessageUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetContactMessageQueryKey = (id: number) => {
  return [`/api/contact/${id}`] as const;
};

export const getGetContactMessageQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactMessage>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContactMessage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactMessageQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactMessage>>
  > = ({ signal }) => getContactMessage(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactMessage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactMessageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactMessage>>
>;
export type GetContactMessageQueryError = ErrorType<unknown>;

/**
 * @summary Get a single contact message
 */

export function useGetContactMessage<
  TData = Awaited<ReturnType<typeof getContactMessage>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContactMessage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetContactMessageQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete a contact message
 */
export const getDeleteContactMessageUrl = (id: number) => {
  return `/api/contact/${id}`;
};

export const deleteContactMessage = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResult> => {
  return customFetch<DeleteResult>(getDeleteContactMessageUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteContactMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContactMessage>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContactMessage>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteContactMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContactMessage>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteContactMessage(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContactMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContactMessage>>
>;

export type DeleteContactMessageMutationError = ErrorType<unknown>;

/**
 * @summary Delete a contact message
 */
export const useDeleteContactMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContactMessage>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteContactMessage>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteContactMessageMutationOptions(options));
};

/**
 * @summary Submit an athlete join application
 */
export const getSubmitApplicationUrl = () => {
  return `/api/applications`;
};

export const submitApplication = async (
  applicationInput: ApplicationInput,
  options?: RequestInit,
): Promise<Application> => {
  return customFetch<Application>(getSubmitApplicationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(applicationInput),
  });
};

export const getSubmitApplicationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitApplication>>,
    TError,
    { data: BodyType<ApplicationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitApplication>>,
  TError,
  { data: BodyType<ApplicationInput> },
  TContext
> => {
  const mutationKey = ["submitApplication"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitApplication>>,
    { data: BodyType<ApplicationInput> }
  > = (props) => {
    const { data } = props ?? {};

    return submitApplication(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitApplication>>
>;
export type SubmitApplicationMutationBody = BodyType<ApplicationInput>;
export type SubmitApplicationMutationError = ErrorType<unknown>;

/**
 * @summary Submit an athlete join application
 */
export const useSubmitApplication = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitApplication>>,
    TError,
    { data: BodyType<ApplicationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitApplication>>,
  TError,
  { data: BodyType<ApplicationInput> },
  TContext
> => {
  return useMutation(getSubmitApplicationMutationOptions(options));
};

/**
 * @summary List all athlete applications (admin)
 */
export const getListApplicationsUrl = () => {
  return `/api/applications`;
};

export const listApplications = async (
  options?: RequestInit,
): Promise<Application[]> => {
  return customFetch<Application[]>(getListApplicationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListApplicationsQueryKey = () => {
  return [`/api/applications`] as const;
};

export const getListApplicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listApplications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listApplications>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListApplicationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listApplications>>
  > = ({ signal }) => listApplications({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listApplications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListApplicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listApplications>>
>;
export type ListApplicationsQueryError = ErrorType<unknown>;

/**
 * @summary List all athlete applications (admin)
 */

export function useListApplications<
  TData = Awaited<ReturnType<typeof listApplications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listApplications>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListApplicationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single application
 */
export const getGetApplicationUrl = (id: number) => {
  return `/api/applications/${id}`;
};

export const getApplication = async (
  id: number,
  options?: RequestInit,
): Promise<Application> => {
  return customFetch<Application>(getGetApplicationUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetApplicationQueryKey = (id: number) => {
  return [`/api/applications/${id}`] as const;
};

export const getGetApplicationQueryOptions = <
  TData = Awaited<ReturnType<typeof getApplication>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApplication>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApplicationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplication>>> = ({
    signal,
  }) => getApplication(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApplication>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApplicationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApplication>>
>;
export type GetApplicationQueryError = ErrorType<unknown>;

/**
 * @summary Get a single application
 */

export function useGetApplication<
  TData = Awaited<ReturnType<typeof getApplication>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApplication>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApplicationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update application status (admin)
 */
export const getUpdateApplicationStatusUrl = (id: number) => {
  return `/api/applications/${id}`;
};

export const updateApplicationStatus = async (
  id: number,
  applicationStatusUpdate: ApplicationStatusUpdate,
  options?: RequestInit,
): Promise<Application> => {
  return customFetch<Application>(getUpdateApplicationStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(applicationStatusUpdate),
  });
};

export const getUpdateApplicationStatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateApplicationStatus>>,
    TError,
    { id: number; data: BodyType<ApplicationStatusUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateApplicationStatus>>,
  TError,
  { id: number; data: BodyType<ApplicationStatusUpdate> },
  TContext
> => {
  const mutationKey = ["updateApplicationStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateApplicationStatus>>,
    { id: number; data: BodyType<ApplicationStatusUpdate> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateApplicationStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateApplicationStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateApplicationStatus>>
>;
export type UpdateApplicationStatusMutationBody =
  BodyType<ApplicationStatusUpdate>;
export type UpdateApplicationStatusMutationError = ErrorType<unknown>;

/**
 * @summary Update application status (admin)
 */
export const useUpdateApplicationStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateApplicationStatus>>,
    TError,
    { id: number; data: BodyType<ApplicationStatusUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateApplicationStatus>>,
  TError,
  { id: number; data: BodyType<ApplicationStatusUpdate> },
  TContext
> => {
  return useMutation(getUpdateApplicationStatusMutationOptions(options));
};

/**
 * @summary Delete an application
 */
export const getDeleteApplicationUrl = (id: number) => {
  return `/api/applications/${id}`;
};

export const deleteApplication = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResult> => {
  return customFetch<DeleteResult>(getDeleteApplicationUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteApplicationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApplication>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApplication>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteApplication"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApplication>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApplication(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApplication>>
>;

export type DeleteApplicationMutationError = ErrorType<unknown>;

/**
 * @summary Delete an application
 */
export const useDeleteApplication = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApplication>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApplication>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteApplicationMutationOptions(options));
};

/**
 * @summary List all CMS sections
 */
export const getListCmsSectionsUrl = () => {
  return `/api/cms`;
};

export const listCmsSections = async (
  options?: RequestInit,
): Promise<CmsSection[]> => {
  return customFetch<CmsSection[]>(getListCmsSectionsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCmsSectionsQueryKey = () => {
  return [`/api/cms`] as const;
};

export const getListCmsSectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCmsSections>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCmsSections>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCmsSectionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCmsSections>>> = ({
    signal,
  }) => listCmsSections({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCmsSections>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCmsSectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCmsSections>>
>;
export type ListCmsSectionsQueryError = ErrorType<unknown>;

/**
 * @summary List all CMS sections
 */

export function useListCmsSections<
  TData = Awaited<ReturnType<typeof listCmsSections>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCmsSections>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCmsSectionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a CMS section by key
 */
export const getGetCmsSectionUrl = (key: string) => {
  return `/api/cms/${key}`;
};

export const getCmsSection = async (
  key: string,
  options?: RequestInit,
): Promise<CmsSection> => {
  return customFetch<CmsSection>(getGetCmsSectionUrl(key), {
    ...options,
    method: "GET",
  });
};

export const getGetCmsSectionQueryKey = (key: string) => {
  return [`/api/cms/${key}`] as const;
};

export const getGetCmsSectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getCmsSection>>,
  TError = ErrorType<unknown>,
>(
  key: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCmsSection>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCmsSectionQueryKey(key);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCmsSection>>> = ({
    signal,
  }) => getCmsSection(key, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!key,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCmsSection>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCmsSectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCmsSection>>
>;
export type GetCmsSectionQueryError = ErrorType<unknown>;

/**
 * @summary Get a CMS section by key
 */

export function useGetCmsSection<
  TData = Awaited<ReturnType<typeof getCmsSection>>,
  TError = ErrorType<unknown>,
>(
  key: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCmsSection>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCmsSectionQueryOptions(key, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create or update a CMS section by key
 */
export const getUpsertCmsSectionUrl = (key: string) => {
  return `/api/cms/${key}`;
};

export const upsertCmsSection = async (
  key: string,
  cmsSectionInput: CmsSectionInput,
  options?: RequestInit,
): Promise<CmsSection> => {
  return customFetch<CmsSection>(getUpsertCmsSectionUrl(key), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cmsSectionInput),
  });
};

export const getUpsertCmsSectionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertCmsSection>>,
    TError,
    { key: string; data: BodyType<CmsSectionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertCmsSection>>,
  TError,
  { key: string; data: BodyType<CmsSectionInput> },
  TContext
> => {
  const mutationKey = ["upsertCmsSection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertCmsSection>>,
    { key: string; data: BodyType<CmsSectionInput> }
  > = (props) => {
    const { key, data } = props ?? {};

    return upsertCmsSection(key, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertCmsSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertCmsSection>>
>;
export type UpsertCmsSectionMutationBody = BodyType<CmsSectionInput>;
export type UpsertCmsSectionMutationError = ErrorType<unknown>;

/**
 * @summary Create or update a CMS section by key
 */
export const useUpsertCmsSection = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertCmsSection>>,
    TError,
    { key: string; data: BodyType<CmsSectionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertCmsSection>>,
  TError,
  { key: string; data: BodyType<CmsSectionInput> },
  TContext
> => {
  return useMutation(getUpsertCmsSectionMutationOptions(options));
};

/**
 * @summary Request a presigned URL for file upload
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<UploadUrlResponse> => {
  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<UploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>;
export type RequestUploadUrlMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * @summary Serve a public asset
 */
export const getGetPublicObjectUrl = (filePath: string) => {
  return `/api/storage/public-objects/${filePath}`;
};

export const getPublicObject = async (
  filePath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetPublicObjectUrl(filePath), {
    ...options,
    method: "GET",
  });
};

export const getGetPublicObjectQueryKey = (filePath: string) => {
  return [`/api/storage/public-objects/${filePath}`] as const;
};

export const getGetPublicObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  filePath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({
    signal,
  }) => getPublicObject(filePath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!filePath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPublicObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicObject>>
>;
export type GetPublicObjectQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Serve a public asset
 */

export function useGetPublicObject<
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  filePath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPublicObjectQueryOptions(filePath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Serve an uploaded object
 */
export const getGetStorageObjectUrl = (objectPath: string) => {
  return `/api/storage/objects/${objectPath}`;
};

export const getStorageObject = async (
  objectPath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetStorageObjectUrl(objectPath), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageObjectQueryKey = (objectPath: string) => {
  return [`/api/storage/objects/${objectPath}`] as const;
};

export const getGetStorageObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStorageObject>>
  > = ({ signal }) =>
    getStorageObject(objectPath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!objectPath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageObject>>
>;
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Serve an uploaded object
 */

export function useGetStorageObject<
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageObjectQueryOptions(objectPath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
